export default __webpack_public_path__ + "static/media/money.7f80d15f.svg";